import React, { useEffect } from 'react';
import { Card, Col, message, Progress, Row, Tooltip } from 'antd';
import tileIcon from "./../../assets/obo-tile-icon.svg";
import { useDispatch } from 'react-redux';
import { fetchOBOReport_ChartData } from '../../store/reducers/oboDashboardSlice';
import { formatNumberWithCommas, formatToTwoDecimalPlaces, rejectedApiMessage } from '../../utilities/CommonHelper';

interface OboChartsContainerProps {
    allChartData: any
}


const OboChartsContainer: React.FC<OboChartsContainerProps> = ({ allChartData }) => {
    const dispatch= useDispatch();
    // const [allchartData, setAllChartData] = React.useState<any[]>([]);
    const [totalOppsData, setTotalOppsData] = React.useState<any>({});
    const [totalRevenueData, setTotalRevenueData] = React.useState<any>({});
    const [totalOboData, setTotalOboData] = React.useState<any>({});
    const [totalContractValueData, setTotalContractValueData] = React.useState<any>({});
    const [pecentTotalRevenue, setPecentTotalRevenue] = React.useState<any>(0);
    const [percentRevenue, setPercentRevenue] = React.useState<any>(0);
    const data = [
      ["Month", "Sales"],
      ["2013", 1000],
      ["2014", 1170],
      ["2015", 660],
      ["2016", 1030],
    ];
    
    // const options_totalOpportunities = {
    //   legend: "none",

    //   pieStartAngle: 100, // Rotates the chart
    //   sliceVisibilityThreshold: 0.02, // Hides slices smaller than 2%
      
    // };

    const options_totalOpportunities = {
      // isStacked: true,
      // title: "Company Performance",
      hAxis: {
        title: "Number of Opportunities",
      },
      vAxis: {
        // title: "Months",
      },
      legend: "none",
    };

    const options_totalContractValue = {
      // title: "Line Chart Example",
      // hAxis: { title: "Months" },
      // vAxis: { title: "Amount" },
      // legend: "none",


      // curveType: "function", // Smooths the lines
      // // legend: { position: "bottom" },
      // hAxis: {
      //   title: "Months",
      //   // gridlines: { count: 15 },
      // },
      // vAxis: {
      //   title: "Amount",
      //   gridlines: { color: "none" },
      // },
      // colors: ["#a52714", "#097138"],
      // lineWidth: 4,
      // intervals: { style: "area" },

      hAxis: {
        title: "Total Contract Value",
      },
      vAxis: {
        // title: "Months",
      },
      legend: "none",
    };
    
    const options_OboValue = {
      // title: "Line Chart Example",
      hAxis: { title: "OBO Value" },
      // vAxis: { title: "Amount" },
      legend: "none",
    };

  useEffect(() => {
    if(allChartData && allChartData.length>0){
        let _temp= allChartData[0];
        setTotalOppsData(_temp.totalOpportunity);
        setTotalRevenueData(_temp.totalRevenue);
        setTotalOboData(_temp.oboValue);
        setTotalContractValueData(_temp.totalContractValue);
        const _percentTotalRevenue= _temp.totalRevenue.totalRevenve/_temp.totalContractValue.totalContractValue*100;
        console.log("percentTotalRevenue",_percentTotalRevenue);
        setPecentTotalRevenue(_percentTotalRevenue);
        const _percentRevenue = _temp.totalRevenue.revenue/_temp.totalRevenue.totalRevenve*100;
        console.log("totalRevenue",_temp.totalRevenue.revenue);
        console.log("totalRevenue",_temp.totalRevenue);
        console.log("percentRevenue",_percentRevenue);
        setPercentRevenue(_percentRevenue);
    }
    
  }, [allChartData]);



const getTotalOpportunitesData = (data:any) => {
  const temp: any[] =[];
      temp.push(['Month', 'Number of Opportunities']);
      Object.keys(data).forEach((key) => {
        const value = data[key];
        temp.push([key, value]);
      })
    return temp;
}

const getTotalContractValueData = (data:any) => {
  const temp: any[] =[];
      temp.push(['Month', 'Total Contract Value']);
      Object.keys(data).forEach((key) => {
        const value = data[key];
        temp.push([key, parseFloat(value)]);
      })
    return temp;
}

const getOboValueData = (data:any) => {
  const temp: any[] =[];
      temp.push(['Month', 'OBO Value']);
      Object.keys(data).forEach((key) => {
        const value = data[key];
        temp.push([key, parseFloat(value)]);
      })
    return temp;
}

const convertCuurencyintoBillionMillionThousandFormat = (value:any) => {
    if(value>=1000000000){
      return `${(value/1000000000).toFixed(2)}B`;
    }
    else if(value>=1000000){
      return `${(value/1000000).toFixed(2)}M`;
    }
    else if(value>=1000){
      return `${(value/1000).toFixed(2)}K`;
    }
    else{
      return value
    }
  }

  return (  <>
                    <div className='roww'>
            <div className='col-lg-12'>
              <Row gutter={16}>
                <Col span={5}>
                  <Card  bordered={true} style={{    boxShadow: '5px 10px #e4dede'}}>
                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                    <div 
                                    // style={{width:'50%'}}
                                    >
                                            <div  style={{alignContent:'center'}}>
                                                <span>
                                                <img src={tileIcon} alt='image' width={14} height={14} />
                                                <span  style={{paddingLeft:'10px'}} className='header-obo'>Total Opportunities</span>
                                                </span>
                                                <p style={{fontSize:'2.5em', fontWeight:'bold', color:'#000000'}}>
                                                    {totalOppsData.totalOpportunity}
                                                </p>
                                                
                                            </div>
                                        </div>
                                    {/* <div style={{width:'50%'}}> 
                                        <Chart 

                                        chartType="BarChart"
                                        data={getTotalOpportunitesData(totalOppsData.opportunityGraph||{})}
                                        options={options_totalOpportunities}
                                        
                                        width={"100%"}
                                        height="124px"
                                        />
    
                                    </div> */}
                                </div>
                  </Card>
                </Col>
                <Col span={5}>
                  <Card  bordered={true}  style={{    boxShadow: '5px 10px #e4dede'}}>
                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                    <div 
                                    // style={{width:'50%'}}
                                    >
                                            <div style={{alignContent:'center'}}>
                                                <span>
                                                <img src={tileIcon} alt='image' width={14} height={14} />
                                                <span  style={{paddingLeft:'10px'}} className='header-obo'>Total Contract Value</span>
                                                </span>
                                                <p style={{fontSize:'2.5em', fontWeight:'bold', color:'#000000'}}>
                                                <Tooltip title={`$${formatNumberWithCommas(formatToTwoDecimalPlaces(totalContractValueData.totalContractValue))}` } >
                                                    ${convertCuurencyintoBillionMillionThousandFormat(totalContractValueData.totalContractValue)}
                                                </Tooltip>
                                                </p>
                                                
                                            </div>
                                        </div>
                                    {/* <div style={{width:'50%'}}> 
                                    <Chart
                                      chartType="BarChart"
                                      width="100%"
                                      height="124px"
                                      data={getTotalContractValueData(totalContractValueData.contractValueGraph||{})}
                                      options={options_totalContractValue}
                                    />
    
                                    </div> */}
                                </div>
                  </Card>
                </Col>
              {/* </Row> */}
              {/* <Row gutter={16} style={{ marginTop: '16px' }}> */}
              <Col span={5}>
                  <Card  bordered={true} style={{    boxShadow: '5px 10px #e4dede'}}>
                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                    <div 
                                    // style={{width:'50%'}}
                                    >
                                            <div style={{alignContent:'center'}}>
                                                <span>
                                                <img src={tileIcon} alt='image' width={14} height={14} />
                                                <span  style={{paddingLeft:'10px'}} className='header-obo'>Total OBO</span>
                                                </span>
                                                <p style={{fontSize:'2.5em', fontWeight:'bold', color:'#000000'}}>
                                                <Tooltip title={`$${formatNumberWithCommas(formatToTwoDecimalPlaces(totalOboData.totalOboValue))}` } >
                                                    ${convertCuurencyintoBillionMillionThousandFormat(totalOboData.totalOboValue)}
                                                </Tooltip>
                                                </p>
                                                
                                            </div>
                                        </div>
                                    {/* <div style={{width:'50%'}}> 

                                        <Chart
                                          chartType="BarChart"
                                          width="100%"
                                          height="124px"
                                          data={getOboValueData(totalOboData.oboGraph||{})}
                                          options={options_OboValue}
                                        />
    
                                    </div> */}
                                </div>
                  </Card>
                </Col>
                <Col span={9}>
                  <Card  bordered={true} style={{    boxShadow: '5px 10px #e4dede'}}>
                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                    <div 
                                    style={{width:'50%'}}
                                    >
                                            <div style={{alignContent:'center'}}>
                                                <span>
                                                <img src={tileIcon} alt='image' width={14} height={14} />
                                                <span  style={{paddingLeft:'10px'}} className='header-obo'>Total Revenue</span>
                                                </span>
                                                <p style={{fontSize:'2.5em', fontWeight:'bold', color:'#000000' ,
                                                  // marginTop:'10px' 
                                                  }}>
                                                <Tooltip title={`$${formatNumberWithCommas(formatToTwoDecimalPlaces(totalRevenueData.totalRevenve))}` } >
                                                    ${convertCuurencyintoBillionMillionThousandFormat(totalRevenueData.totalRevenve)}
                                                </Tooltip>
                                                {/* <Progress type="circle" percent={pecentTotalRevenue} format={(percent) => 
                                                  <Tooltip title={`$${formatNumberWithCommas(totalRevenueData.totalRevenve)}` } >
                                                    ${totalRevenueData.totalRevenve?convertCuurencyintoBillionMillionThousandFormat(totalRevenueData.totalRevenve):'0'}
                                                  </Tooltip>
                                                  } /> */}
                                                </p>
                                                
                                            </div>
                                        </div>
                                    <div style={{width:'50%'}}> 
                                    <div style={{alignContent:'center'}}>
                                                <span>
                                                <img src={tileIcon} alt='image' width={14} height={14} />
                                                <span  style={{paddingLeft:'10px'}} className='header-obo'>Revenue For The Period</span>
                                                </span>
                                                <p style={{fontSize:'2.5em', fontWeight:'bold', color:'#000000',
                                                  // marginTop:'10px' 
                                                  }}>
                                                <Tooltip title={`$${formatNumberWithCommas(formatToTwoDecimalPlaces(totalRevenueData.revenue))}` } >
                                                    ${convertCuurencyintoBillionMillionThousandFormat(totalRevenueData.revenue)}
                                                </Tooltip>
                                                {/* <Progress type="circle"  percent={percentRevenue} format={(percent) => 
                                                  <Tooltip title={`$${formatNumberWithCommas(totalRevenueData.revenue)}` } >
                                                    ${totalRevenueData.revenue?convertCuurencyintoBillionMillionThousandFormat(totalRevenueData.revenue):'0'}
                                                  </Tooltip>
                                                  } /> */}
                                                </p>
                                                
                                            </div>
                                    </div>
                                </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
          </>
  );
};

export default OboChartsContainer;